import { Command } from 'commander';
import { isCliError, ExitCode, isWportError, exitCodeForError } from './lib/errors';
import { isColorEnabled, printError } from './lib/output';
import { registerJobsCommand } from './commands/jobs';
import { registerConfigCommand } from './commands/config';
import { registerDoctorCommand } from './commands/doctor';
import { registerEnterpriseCommand } from './commands/enterprise';
import { registerLoginCommand } from './commands/auth/login';
import { registerWhoamiCommand } from './commands/auth/whoami';
import { registerLogoutCommand } from './commands/auth/logout';
import { registerSessionsCommand } from './commands/sessions';
import { registerPersonalCommand } from './commands/personal';

const program = new Command();

program
	.name('wport')
	.description('wport CLI — terminal interface to the W101 Talent Search Hub public API')
	.version(__CLI_VERSION__, '-v, --version', 'output the CLI version')
	.option('--lang <locale>', 'Accept-Language locale: zh-TW | en-US | vi-VN | th-TH | id-ID')
	.option('--api <url>', 'override API base URL')
	.option('--output <fmt>', 'output format: table | json')
	.option('--no-color', 'disable color output')
	.option('--timeout <ms>', 'HTTP timeout in milliseconds', (v) => Number(v));

registerJobsCommand(program);
registerConfigCommand(program);
registerDoctorCommand(program);
registerEnterpriseCommand(program);
registerLoginCommand(program);
registerWhoamiCommand(program);
registerLogoutCommand(program);
registerSessionsCommand(program);
registerPersonalCommand(program);

program.exitOverride();

program
	.parseAsync(process.argv)
	.then(() => process.exit(ExitCode.Success))
	.catch((err: unknown) => handleTopLevelError(err));

function handleTopLevelError(err: unknown): never {
	const color = isColorEnabled(false);

	// commander throws CommanderError on its own validation paths (help, version, unknown option).
	if (err && typeof err === 'object' && 'code' in err) {
		const commanderErr = err as { code?: string; exitCode?: number; message?: string };
		if (commanderErr.code === 'commander.helpDisplayed' || commanderErr.code === 'commander.version') {
			process.exit(ExitCode.Success);
		}
		// commander 自己的 exitCode 多半是 1，不在 CLI 的 contract（0/2/3/4/5）內。
		// 任何 parsing / usage 失敗都當 InvalidArgument(2)。
		if (commanderErr.message) printError(commanderErr.message, color);
		process.exit(ExitCode.InvalidArgument);
	}

	if (isCliError(err)) {
		printError(err.message, color);
		process.exit(err.exitCode);
	}

	if (isWportError(err)) {
		printError(err.message, color);
		process.exit(exitCodeForError(err));
	}

	const fallbackMessage = err instanceof Error ? err.message : String(err);
	printError(fallbackMessage, color);
	process.exit(ExitCode.ServerOrNetworkError);
}
